import { validateResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
import { placeDetailsResponseSpec } from "./specs.js";
const getPlaceDetails = async (apiUrl, request) => {
  return validateResponse(
    placeDetailsResponseSpec,
    await fetch(`${apiUrl}/place/details?place_id=${request.id}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
export {
  getPlaceDetails
};
//# sourceMappingURL=place-details.js.map
